
<template>
    <b-modal :no-close-on-backdrop="true" id="modal-property-tree" modal-class="modal-avenue-of-feedback" title="Search Avenue Of Feedback" hide-footer :centered="true" v-model="open">
        <b-form class="px-4">
            <gofix-form-dropdown
                vLabel="reference_value_text"
                label="Avenue Of Feedback"
                :options="options"
                v-model="selected"
                :disabled="disabled"
                class="gofixInputNoMinWidth">
            </gofix-form-dropdown>
        </b-form>
        <b-button-group class="d-block text-right p-1rem pt-0">
            <gofix-button :disabled="$route.params.id != 0 && Item && (Item.status === 'Cancelled' || disabled)" label="APPLY" @click="applyData" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>
<script>

import { mapGetters } from 'vuex';
export default {
    name: 'modal-avenue-of-feedback',
    components: {},
    props: {
        value: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default: () => []
        },
        valueSelected: {
            type: Object,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false,
            selected: null,
        }
    },
    watch: {
        value: function (val) {
            if(val) {
                if(this.valueSelected) this.selected = this.valueSelected;
            }
            this.open = val;
        },
        open: function (val) {
            this.$emit('input', val);
        },
        contract_id: function(val) {
            this.getData();
        }
    },
    computed: {
        ...mapGetters({
            Item: "CaseManagementController/Item",
        }),
    },
    methods: {
        applyData() {
            this.$emit('updateData', this.selected)
            this.open = false;
        }
    }
}
</script>